module.exports = __webpack_public_path__ + "asset/venn--2abd3f.png";